import { Component, Input } from "@angular/core"

@Component({
    selector: "app-funders",
    templateUrl: "./funders.component.html",
    styleUrls: ["./funders.component.scss"],
    standalone: false,
})
export class FundersComponent {
    @Input() public funders: any[]
    @Input() public credits: any[]
}
